import ObjectiveForm from 'vcomponents/objectives/create/ObjectiveForm.vue';
import ObjectiveLandingPage from 'vcomponents/objectives/landing/ObjectiveLandingPage.vue';
import ObjectivesListing from 'vcomponents/objectives/listing/ObjectivesListing.vue';

export default [
    {
        path: '/objectives',
        name: 'objectives',
        component: ObjectivesListing,
    },
    {
        path: '/objectives/create',
        name: 'objectives.create',
        component: ObjectiveForm,
        props: true,
    },
    {
        path: '/objectives/try-objective',
        name: 'objectives.landingPage',
        component: ObjectiveLandingPage,
    },
];
